<template>
  <nav class="cfm-navbar flex flex-vcenter flex-space-between">
    <div class="cfm-brand">
      <a v-if="isPLAorSFGTAPage" class="brand" @click.prevent> <div id="cfm-logo">myCFM Portal</div> </a>
      <a v-else class="brand" @click="gotoHome"> <div id="cfm-logo">myCFM Portal</div> </a>
    </div>
    <div class="logo-cfm-right">
      <a class="brand" @click="gotoHome">
        <img src="./../images/CFM_Tagline_Left.png" width="150px" height="54px" />
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    isPLAorSFGTAPage() {
      return (
        this.$route.path.includes("sfgta-agreement") ||
        this.$route.path.includes("sfgtaSuccess")
      );
    }
  },
  methods: {
    gotoHome() {
      this.$router.push("/");
      // reload to refresh store
      window.location.reload();
    }
  }
};
</script>

<style lang="less" scoped>
.cfm-navbar {
  height: 70px;
  margin-left: auto;
  margin-right: auto;
  background: white;
  border-bottom: solid 1px #ccc;
}
.cfm-brand {
  align-content: flex-start;
  background: url(./../images/cfm_wrapper.png) top no-repeat;
  width: 125px;
  max-width: 100%;
  background-size: 100%;
  left: -5px;
  top: 0;
  height: 70px;
  position: relative;
  float: left;
  cursor: pointer;
}
.brand {
  text-decoration: none;
}
#cfm-logo {
  padding: 1.4em 1.6em;
  width: 260px;
  font-size: 22px;
  font-weight: bold;
  color: #004bbd;
  font-family: apexSans;
}
.logo-cfm-right {
  float: right;
  max-width: 100%;
  padding: 0.6em 15px 9px 0px;
}
</style>
